
export function Debug() {
  return (
            <p><a href={`${process.env.PUBLIC_URL}/debug_install.bat`} download>ダウンロード</a></p>
  )
}
